import React from "react";
import { useDropdownStyle } from "./Dropdown.style";

export function DropdownSeparator() {
    const styles = useDropdownStyle();
    return <div className={styles.dropdownSeparator} />;
}
